import React from "react";
import { Grow, Grid } from "@material-ui/core";

import useStyles from "./styles";
import NewsCard from "./NewsCard/NewsCard";

const NewsCards = ({ articles, activeArticle }) => {
  const classes = useStyles();

  return (
    <Grow in>
      <Grid
        className={classes.container}
        container
        alignItems="stretch"
        spacing={2}
      >
        {articles.map((article, i) => (
          <Grid
            key={i}
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{ display: "flex" }}
          >
            <NewsCard article={article} i={i} activeArticle={activeArticle} />
          </Grid>
        ))}
      </Grid>
    </Grow>
  );
};

export default NewsCards;
